import Vue from 'vue';

export default Vue.mixin({
  methods: {
    parseDecimalInput(value) {
      return parseFloat(value.replace(/[^0-9,]/g, '').replace(',', '.'));
    },
  },
});
